import React from 'react';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';

import SocialFollow from './SocialFollow';
import HistoryLogo from '../../images/battle-map/logo_history.svg';

const Header = ({ siteTitle }) => (
  <header class="battle-map">
    <div className="map_header">
      <div className="logo">
        <a href="https://www.history.com/" target="_blank">
          <img src={HistoryLogo} alt="History Channel" />
        </a>
      </div>
      <h1>
        <a href="https://www.history.com/shows/washington" target="_blank">
          {siteTitle}
        </a>
      </h1>

      <h2>His Key Military Battles</h2>
    </div>
    <SocialFollow />
  </header>
);

Header.propTypes = {
  siteTitle: PropTypes.string,
};

Header.defaultProps = {
  siteTitle: ``,
};

export default Header;
